module.exports = __webpack_public_path__ + "static/img/logo.dbe31372.png";